import client, { USERS_BASE_URL } from 'services/kardAPI';

const createPortalUser = async (body) => {
  try {
    await client.post(`${USERS_BASE_URL}/portal/cognito/user`, body);
  } catch (error) {
    throw new Error(error.response.data);
  }
};

export default createPortalUser;
